import { contactData } from '@/mocks/home-data';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-accent-50 rounded-2xl p-8 md:p-12 border border-accent-200/60">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">{contactData.title}</h2>
            <p className="text-sm font-medium text-accent-700 mb-4">{contactData.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {contactData.description}
            </p>
            <div className="flex flex-col gap-3 max-w-sm mx-auto lg:mx-0">
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100">
                  <i className="ri-mail-line text-accent-600"></i>
                </span>
                <span className="font-medium">{contactData.email}</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100">
                  <i className="ri-wechat-line text-accent-600"></i>
                </span>
                <span className="font-medium">{contactData.wechat}</span>
              </div>
              <p className="text-xs text-accent-600 mt-2">{contactData.responseTime}</p>
            </div>
          </div>
          <div className="flex-shrink-0 hidden lg:block">
            <div className="w-56 h-56 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20QR%20code%20design%20on%20a%20warm%20cream%20background%20with%20subtle%20decorative%20elements%2C%20modern%20editorial%20style%2C%20sophisticated%20layout%2C%20warm%20amber%20accents&width=500&height=500&seq=contact-qr-placeholder&orientation=squarish"
                alt="联系我们 - 吃瓜每日大赛"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}